<template>
  <div class='wrapping'>
    <x-payment-result :msg="msg" :isSuccess="isSuccess" ></x-payment-result>
  </div>
</template>

<script>
import PaymentResult from '@/views/shop/components/paymentResult'

export default {
  name: 'PaymentResult',
  components: {
    'x-payment-result': PaymentResult
  },
  created () {
    this.initEnv()
  },
  data () {
    return {
      deviceType: 'pc',
      isSuccess: true,
      msg: ''
    }
  },
  mounted () {
    let query = this.$route.query || {}
    let type = parseInt(query.x_pay_call_it || 0)

    switch (type) {
      case 8:
        let status = query.status

        switch (status) {
          case 'SUCCESS':
            this.msg = 'Payment Successful'
            this.isSuccess = true
            break
          case 'FAILED':
            this.msg = 'Payment Failed'
            this.isSuccess = false
            break
          case 'CLOSED':
            this.msg = 'Closed'
            this.isSuccess = false
            break
          default:
            this.msg = 'Payment Error'
            this.isSuccess = false
        }
        break
    }
  },
  methods: {
    // 初始过环境
    initEnv () {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/shop/recharge/result.vue